/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ expiresAt: NonNullable<unknown> }} Settings_Reportingapikeys_Reveal_Expiresat3Inputs */

const en_settings_reportingapikeys_reveal_expiresat3 = /** @type {(inputs: Settings_Reportingapikeys_Reveal_Expiresat3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expires: ${i?.expiresAt}`)
};

/**
* | output |
* | --- |
* | "Expires: {expiresAt}" |
*
* @param {Settings_Reportingapikeys_Reveal_Expiresat3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_reveal_expiresat3 = /** @type {((inputs: Settings_Reportingapikeys_Reveal_Expiresat3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Reveal_Expiresat3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_reveal_expiresat3(inputs)
});
export { settings_reportingapikeys_reveal_expiresat3 as "settings_reportingApiKeys_reveal_expiresAt" }